import '@assets/normalize.css'
import './shared/styles/index.css'
import './index.css'
import './index.scss'
import './locales/i18n'
import '@assets/iconfont/iconfont.css'
import '@assets/3d/iconfont.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { useAppConfigStore } from '@/store/appConfig'
import { syncAuthFromPersistedStore } from '@/utils/authToken'

import { router } from './router/index'

syncAuthFromPersistedStore()

// 应用启动时拉取配置中心公开配置（非阻塞，失败自动回退到 env 默认值）
useAppConfigStore.getState().load()

// HTTP 强制跳转 HTTPS（仅生产环境 + 配置的域名；本地 dev 不跳转，避免 ERR_SSL_PROTOCOL_ERROR）
const APP_HOSTNAME = import.meta.env.VITE_APP_HOSTNAME
if (
  import.meta.env.PROD &&
  APP_HOSTNAME &&
  window.location.hostname === APP_HOSTNAME &&
  window.location.protocol === 'http:'
) {
  window.location.replace(
    `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`,
  )
}

// 渲染应用
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)

// stp需要的静态文件
const loadScript = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.defer = true

    script.onload = () => {
      console.log(`脚本 ${url} 加载成功`)
      resolve()
    }

    script.onerror = () => {
      console.error(`脚本 ${url} 加载失败`)
      reject(new Error(`脚本 ${url} 加载失败`))
    }

    // 添加完整性验证（如果有SRI哈希值）
    // script.integrity = "sha384-..."
    // script.crossOrigin = "anonymous"

    document.body.appendChild(script)
  })
}

// 加载stp工具脚本
loadScript('/occ_stp_tool.js').catch((error) => {
  console.error('stp工具脚本加载失败，可能影响相关功能', error)
})
